<ng-container>
  <section *transloco="let t">
    <div class="popup-header row no-margin ">
      <div class="col-xs-12 mb-5 d-flex j-space-between">
        <div>
          <h1>{{'settings.outlook_enterprise.title' | transloco}}</h1>
          <p class="mt-10">{{'settings.outlook_enterprise.description' | transloco}}</p>
        </div>
        <button type="button" class="close a-self-start" (click)="onClose()">
          <span aria-hidden="true"><mat-icon class="d-text-middle">close</mat-icon>
          </span>
          <span class="sr-only">Close</span>
        </button>
      </div>
    </div>
    <form #outlookForm="ngForm" (ngSubmit)="submit()">
      <div class="popup-body" appScroll>
        <div class="row">
          <div class="col-md-12">
            <div class="col-md-6">
              <mat-form-field class="full-width">
                <mat-label>{{'settings.outlook_enterprise.client_id' | transloco}}</mat-label>
                <input matInput name="client_id" [(ngModel)]="entity.client_id" required>
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field class="full-width">
                <mat-label>{{'settings.outlook_enterprise.client_secret' | transloco}}</mat-label>
                <input [type]="isSecretVisible ? 'text' : 'password'" matInput name="client_secret"
                  [(ngModel)]="entity.client_secret" required>
                <mat-icon matSuffix (click)="isSecretVisible = !isSecretVisible" style="cursor: pointer">
                  {{isSecretVisible ? 'visibility' : 'visibility_off'}}
                </mat-icon>
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field class="full-width">
                <mat-label>{{'settings.outlook_enterprise.tenant_id' | transloco}}</mat-label>
                <input matInput name="tenant_id" [(ngModel)]="entity.tenant_id" required>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="popup-footer">
        <button mat-stroked-button type="button" class="mr-3"
          (click)="onClose()">{{t('settings.outlook_enterprise.cancel') |
          titlecase}}</button>
        <button mat-flat-button color="primary" type="submit" [disabled]="!outlookForm.valid || processing">
          <span *ngIf="processing" class="spinner"></span>
          {{t('settings.outlook_enterprise.save') | titlecase}}
        </button>
      </div>
    </form>
  </section>
</ng-container>